import { useMutation } from '@src/query';


/**
 * Item-specifics query key for a part (#273). Mirrors the URL-derived key scheme
 * `['root', ...url.split('/')]` for `/inventory/parts/<seller>/<part>/item-specifics/`.
 */
function itemSpecificsKey(sellerId, partId) {
  return ['root', '', 'inventory', 'parts', sellerId, partId, 'item-specifics', ''];
}


/**
 * Listing-copy query key for a part — invalidated on save so the generated copy
 * reflects newly-stored specifics.
 */
function listingCopyKey(sellerId, partId) {
  return ['root', '', 'inventory', 'parts', sellerId, partId, 'listing-copy', ''];
}


/**
 * Save a part's item specifics (#273). Variables: `{ sellerId, partId, specifics }`.
 * PATCHes `{ specifics }`, then invalidates the checklist AND listing-copy queries
 * so both refetch. Follows the injected `{ apiClient, queryClient }` contract.
 */
function useSaveItemSpecificsMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, partId, specifics }) => apiClient
      .request({
        url: `/inventory/parts/${sellerId}/${partId}/item-specifics/`,
        method: 'PATCH',
        payload: { specifics },
      })
      .then((data) => {
        queryClient.invalidateQueries({ queryKey: itemSpecificsKey(sellerId, partId) });
        queryClient.invalidateQueries({ queryKey: listingCopyKey(sellerId, partId) });
        return data;
      }),
    ...params,
  });
}


export { itemSpecificsKey, useSaveItemSpecificsMutation };
